import StatusButton from './StatusButton';

export default StatusButton;
